module.exports = __webpack_public_path__ + "img/Untitled-2.a0ab2856.png";